// extracted by mini-css-extract-plugin
export default {"tableHeaderWrap":"tableHeaderCell_tableHeaderWrap__LYiKu","tableHeaderCell":"tableHeaderCell_tableHeaderCell__c5E6c","tableHeaderTitle":"tableHeaderCell_tableHeaderTitle__ZxG8k"};